import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import {utility} from 'src/app/common/utility';
import { ResourceService } from 'src/app/services/ResourceService';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-resource-list-view',
  templateUrl: './resource-list-view.component.html',
  styleUrls: ['./resource-list-view.component.scss'],
  providers: [ConfirmationService]
})
export class ResourceListViewComponent implements OnInit {

  resources:any[];
  msgs:Message[];
    searchterm: string;
    canAddResource: boolean = false;
    canEditResource: boolean = false;
    canDeleteResource: boolean = false;
    resourceCategory: string;

  constructor(private activatedRoute: ActivatedRoute, private breadcrumbService: AppBreadcrumbService, private router: Router, 
      private resourceservice: ResourceService, private confirmationService: ConfirmationService, private accountService: AccountService) {    
}

  ngOnInit(): void {
    this.resources = this.activatedRoute.snapshot.data['resources'];
    let id = this.activatedRoute.snapshot.params.categoryid;
      let searchterm = this.activatedRoute.snapshot.params.searchterm;
      if (this.resources != undefined && this.resources.length > 0) {
          this.resourceCategory = this.resources[0].ResourceCategoryName;
      }

    var routelnk =  'resource-center/view';

    if(id!== undefined)
    {
      routelnk =  'resource-list/' + id;
    }
    else if(searchterm!== undefined)
    {
      routelnk =  'resource-list/search/' + searchterm;
    }
    this.breadcrumbService.setItems([
      { label: 'Resource-Center', routerLink: ['resource-center/view'] },
        { label: this.resourceCategory, routerLink: [] }
  ]);
      this.canAddResource = this.accountService.CanAddResource();
      this.canEditResource = this.accountService.CanEditResource();
      this.canDeleteResource = this.accountService.CanDeleteResource();
  }
  getDocumentUrl(doc: any): string {
    var result;
    if(doc.FileTypeID != 7)
    {
      result = environment.imageBase.concat('/', doc.DocumentURI);
    }
    else
    {
       result = doc.DocumentURI
    }
  
    return result;
  }  

  OpenUrl(doc: any) {
      var url = this.getDocumentUrl(doc);
      utility.OpenURl(url);
   
  }

  SearchResources($event)
  {
     this.router.navigate(['/resource-list/search/'+ this.searchterm]);
  }

  deleteResource(Resource) {
    this.confirmationService.confirm({
      key: "DeleteResourceConfirmDialog",
      message: 'Are you sure you want to delete this Resource?',
      accept: () => {

        this.resourceservice.InactivateResource(Resource.Id).subscribe(res => {        
          let index = this.resources.indexOf(Resource);            
          this.resources = this.resources.filter((val, i) => i != index);     
        });    
        
      }
    });
    
  }

  getIcon(doc):string
  {
    let fileicon = utility.getDocumentIconClass(doc);
    return fileicon;
  }

}
